import React from 'react'
import USDefaultTemplate from 'src/components/template/us'
import { networkLogos } from 'src/constants/networkLogos'

export default (props) => {
  return (
    <USDefaultTemplate
      location={props.location}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/NFLNetwork2021.mp4'}
      staticAnnotation={networkLogos.nflnetwork}
      title="Watch NFL Network live"
      subtitle="Exclusive NFL games, analysis and more"
      networkSet="nfl"
      // Remove cable references
      removeCable={true}
      showRedzone={false}
    />
  )
}
